import React from 'react';
import { usePS2Graphics } from '../context/PS2GraphicsContext';

export default function PS2CrtOverlay() {
  const { crtFilter } = usePS2Graphics();

  if (!crtFilter) return null;

  return (
    <div className="fixed inset-0 pointer-events-none z-[9999] overflow-hidden select-none">
      {/* CRT Scanline Bars */}
      <div
        className="absolute inset-0"
        style={{
          background: 'linear-gradient(rgba(18, 16, 16, 0) 50%, rgba(0, 0, 0, 0.25) 50%), linear-gradient(90deg, rgba(255, 0, 0, 0.03), rgba(0, 255, 0, 0.01), rgba(0, 0, 255, 0.03))',
          backgroundSize: '100% 3px, 6px 100%',
        }}
      />
      {/* Screen Curved Vignette & Phosphor Glow */}
      <div
        className="absolute inset-0"
        style={{
          boxShadow: 'inset 0 0 100px rgba(0, 0, 0, 0.75)',
        }}
      />
      {/* Retro CRT Refresh Line Animation */}
      <div
        className="absolute w-full h-8 opacity-10 bg-gradient-to-b from-cyan-400 via-white to-transparent"
        style={{
          animation: 'crt-scanline 8s linear infinite',
        }}
      />
    </div>
  );
}
